// 简体中文表格（机器翻译，未经人工审校 — ruling G4）。
// The Simplified Chinese table: machine-written from the English table, unread by a native
// reader. Same keys, kinds and placeholders as en.js — held by test/tables.test.js.
const S = {
  styleGroup: "杯垫风格",
  styles: {
    two: "双面",
    logo: "名字 / 标志",
  },
  titles: {
    two: "双面杯垫",
    logo: "带标志的杯垫",
  },
  textHint: (lines, chars) => `最多 ${lines} 行，每行至多 ${chars} 个字符`,
  needFile: "选择标志的 SVG 文件——它只留在您的设备上，不会发送到任何地方",
  artKept: "标志只存在于当前标签页——刷新后需重新选择文件",
  keptOld: "（仍在使用先前的标志）",
  thumb: "已读取标志的预览",
  finish: "标志风格",
  finishes: {
    flush: "平齐",
    raised: "凸起",
    engraved: "雕刻",
  },
  finishNote: {
    flush: "与表面平齐；标志为第二种颜色——需要多色打印机和 3MF 文件（STL 不含标志，为闭合体）",
    raised: (mm) => `凸起 ${mm} 毫米——单喷头打印机换一次料即可得到两种颜色（在“打印”下选“单喷头”）。标志较窄时杯子可能放不稳`,
    engraved: (mm) => `雕刻 ${mm} 毫米深——单色，无需换料`,
  },
  flushNeedsMulti: "平齐效果无法用单喷头打印——请选多色打印",
  scale: "标志大小",
  logoColour: "标志颜色",
  logoPartNames: {
    body: "杯垫主体",
    message: "标志",
  },
  logoZNames: {
    body: "主体颜色",
    message: "标志颜色",
  },
  logoEdgeNote: {
    lip: (mm) => `高出表面 ${mm} 毫米的边能兜住饮品`,
    flat: "无边——同一平面",
  },
  gShape: "形状与边缘",
  gColour: "颜色与打印",
  a: "A 面词语",
  b: "B 面词语",
  wordHint: "B 面朝向对面的人；词语越短越清晰——不超过 6 个字符",
  rows: (n) => `${Math.floor(n)} 行`,
  shape: "形状",
  shapes: {
    round: "圆形",
    square: "方形",
  },
  views: {
    a: "A 面",
    b: "B 面",
    top: "从上方看",
  },
  d: {
    round: "直径",
    square: "宽度",
  },
  mm: (v) => `${v} 毫米`,
  edge: "边缘",
  edges: {
    lip: "凸边",
    flat: "平边",
  },
  edgeNote: {
    lip: "边缘高出台面 1.2 毫米，能兜住饮品",
    flat: "边缘与台面齐平——饮品落在凹槽里",
  },
  looks: "颜色主题",
  lookNames: {
    night: "夜色",
    bee: "黑黄",
    wood: "木纹",
  },
  colour: {
    body: "杯垫主体颜色",
    message: "文字颜色",
  },
  mode: "打印",
  modes: {
    multi: "多色（CFS / AMS）",
    swap: "单喷头，按层换色",
  },
  modeNote: {
    multi: "3MF 有 2 个部件——请在切片软件里分别设置颜色",
    swap: (z1, z2) => `以 0.2 毫米层高打印，并按图下方所示安排换料（在部件的 ${z1} 和 ${z2} 毫米处换色）`,
    swapOne: (layer, z) => `以 ${layer} 毫米层高打印，并按图下方所示安排换料（在部件的 ${z} 毫米处换色）`,
    lipToo: "凸边也会用标志的颜色打印",
    oneColour: "单色——无需设置换色",
  },
  zLine: (layer, filament, name) => `第 ${layer} 层之前，装入 ${filament}（${name}）`,
  partNames: {
    body: "杯垫主体",
    message: "文字",
  },
  zNames: {
    body: "主体颜色",
    message: "文字颜色",
  },
  size: (shape, d, h) => (shape === 'round' ? `Ø ${d} × ${h} 毫米` : `${d} × ${d} × ${h} 毫米`),
  hold: (ml) => `约可盛 ${Math.round(ml)} 毫升`,
  loadingFont: (family, got, total) => (total > 0 ? `正在加载 ${family} ${got.toFixed(1)} / ${total.toFixed(1)} MB` : `正在加载 ${family} ${got.toFixed(1)} MB`),
  problem: {
    "few-rows-a": "A 面词语太长——字母行数少、难以辨认；请换短一些的词",
    "few-rows-b": "B 面词语太长——字母行数少、难以辨认；请换短一些的词",
    "light-body": "杯垫主体应比文字深，否则文字不显眼",
    "thin-text": "字母很细——有些笔画可能打印不出来；请用更大的标志或减少字符",
    "same-colour": "标志颜色与杯垫主体相同——标志将看不到",
    "thin-parts": "标志的细笔画连着厚实部分——切片软件可能把它们切掉",
    dropped: (p) => `已从标志中丢弃 ${p.n} 个过薄、无法打印的部分`,
    "all-thin": "标志对这个尺寸来说太薄——无法下载",
    "art-too-complex": "标志太复杂——无法下载",
  },
  dlstl: "STL",
  copied: "已复制",
  fatal: "无法加载计算器——请尝试刷新页面",
  buildTimeout: "生成 10 秒未完成，已重新开始——请减少字符或换字体",
  beta: "测试版",
  aboutH2: "双面杯垫的原理",
  aboutP1: "杯垫凸起的筋下面藏着一层颜色：坐在 A 侧的人看到一个词，对面的人看到另一个。正上方看不出文字。模拟显示离约 40–100 厘米时最易读。",
  aboutP2: "用 0.2 毫米层高打印。本体用深色、文字用亮色；筋之间的沟槽防止杯子粘住并兜住水滴 — 用完把水擦掉。",
  aboutPrintNote: "这款设计已通过光照和切片模拟，等待实际打印验证。",
  aboutLogoP: "“名字 / 标志”款是平面杯垫：可放文字或店里的 SVG 标志文件，平滑、凸起或雕刻任选。标志文件只留在你的设备上，不会被发送到任何地方。注意：比喷嘴还细的线条或笔画间隙可能被切片软件丢掉或打印后粘在一起 — 打印前先在切片软件里确认。这款在 OrcaSlicer 里做过切片验证，还未实测打印。",
  // the words a page opened with no link starts on (R69): the English words — no bundled family has kana or Han
  start: {
    a: "Cheers",
    b: "LOVE",
  },
};
export default S;
